import type { DebriefEventType, RealEstateCase } from "./types";

export type MeetingPlaybookSignalDefinition = {
  key: string;
  label: string;
  guidance: string;
};

const sellerSignals: MeetingPlaybookSignalDefinition[] = [
  { key: "rapport", label: "Vzťah a dôvera", guidance: "Priebeh socializácie alebo dôkaz dôvery." },
  { key: "seller_motivation", label: "Motivácia predávajúceho", guidance: "Prečo klient predáva." },
  { key: "seller_timing", label: "Časovanie", guidance: "Kedy a s akou naliehavosťou chce obchod vyriešiť." },
  { key: "price_expectation", label: "Cenové očakávanie", guidance: "Očakávaná alebo aktuálna cena." },
  { key: "selling_strategy", label: "Aktuálna stratégia", guidance: "Samopredaj, ďalšia RK alebo iný postup." },
  { key: "value_proposition", label: "Hodnota služby", guidance: "Konkrétna predstavená hodnota alebo služba." },
  { key: "cooperation_test", label: "Test spolupráce", guidance: "Jasný návrh alebo otázka na spoluprácu." },
  { key: "objections", label: "Námietky", guidance: "Námietka klienta a spôsob reakcie." },
  { key: "next_commitment", label: "Konkrétny ďalší krok", guidance: "Dohodnutá akcia, termín a účel." }
];

const buyerSignals: MeetingPlaybookSignalDefinition[] = [
  { key: "rapport", label: "Vzťah a dôvera", guidance: "Reakcia klienta a kvalita kontaktu." },
  { key: "buyer_reaction", label: "Reakcia na nehnuteľnosť", guidance: "Čo kupujúci ocenil alebo odmietol." },
  { key: "buyer_motivation", label: "Motivácia kupujúceho", guidance: "Prečo a dokedy chce kúpiť." },
  { key: "financing", label: "Financovanie", guidance: "Stav financovania alebo úverovej pripravenosti." },
  { key: "decision_maker", label: "Rozhodovateľ", guidance: "Či bol prítomný rozhodovateľ alebo ďalší influencer." },
  { key: "objections", label: "Námietky", guidance: "Potvrdené obavy alebo prekážky." },
  { key: "next_commitment", label: "Konkrétny ďalší krok", guidance: "Dohodnutá akcia, termín a účel." }
];

export const MEETING_PLAYBOOKS: Record<DebriefEventType, MeetingPlaybookSignalDefinition[]> = {
  acquisition_meeting: sellerSignals,
  client_meeting: sellerSignals,
  negotiation: sellerSignals,
  follow_up_meeting: sellerSignals,
  property_viewing: buyerSignals,
  financial_meeting: buyerSignals
};

export const meetingPlaybookContext = (caseItem: RealEstateCase, eventType: DebriefEventType) => ({
  meetingType: eventType,
  expectedSignals: MEETING_PLAYBOOKS[eventType],
  caseContext: {
    transactionType: caseItem.transactionType,
    propertyType: caseItem.propertyType,
    propertyLocation: caseItem.propertyAddress,
    stage: caseItem.stage,
    nextStep: caseItem.nextStep,
    notes: caseItem.notes.slice(0, 2_000)
  }
});
